import { Fragment, useState } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { DotsVerticalIcon, ClipboardIcon, PencilIcon, TrashIcon } from '@heroicons/react/solid';

//functions
import { copyToClipboard } from '../functions/CopyContent';
//import { deleteLikedMsg } from '../functions/DeleteMsg';
import DialogFSPBlueForLiked from '../dialogs/DialogFSPBlueForLiked';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const OptionsForLiked = ({project, profile, deleteMsg, setOpen, openDialog}) => {

  const [save, setSave ] = useState()
  
  const handleClick = (project, setOpen) => {
    setOpen(!openDialog) 
    setSave(project)
  }

  return ( 
    <Menu as="div" className="relative inline-block text-left">
      {({ open }) => (
        <>
          <div>
            <Menu.Button className="bg-gray-100 rounded-full flex items-center text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500">
              <span className="sr-only">Open options</span>
              <DotsVerticalIcon className="h-5 w-5" aria-hidden="true" />
            </Menu.Button>
          </div>
          {save ?
            <div>
              <DialogFSPBlueForLiked
              openDialog={openDialog}
              setOpen={setOpen}
              project={save}
              profile={profile}
              setSave={setSave}
              />
            </div>
          : 
            null
          }
          <Transition
            show={open}
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items
              static
              className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
            >
              <div className="py-1">
                <Menu.Item>
                {({ active }) => (
                    <p
                    className={classNames(
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                      'group flex items-center px-4 py-2 text-sm'
                    )}
                    onClick={() => copyToClipboard(project)}
                  >
                    <ClipboardIcon
                      className="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500"
                      aria-hidden="true"
                    />
                    Copy
                  </p>
                )}
                </Menu.Item>
                <Menu.Item>
                {({ active }) => (
                    <div
                    className={classNames(
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                      'group flex items-center px-4 py-2 text-sm'
                    )}
                    // onClick={() => {setOpen(!openDialog); setSave(project) }}
                    onClick={() =>  handleClick(project, setOpen)}
                  >
                    <PencilIcon
                      className="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500"
                      aria-hidden="true"
                    />
                    Edit
                  </div>
                  
                )}
                </Menu.Item>
                <Menu.Item>
                {({ active }) => (
                    <p
                    className={classNames(
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                      'group flex items-center px-4 py-2 text-sm'
                    )}
                    onClick={() => deleteMsg(project.id, profile)}
                  >
                    <TrashIcon
                      className="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500"
                      aria-hidden="true"
                    />
                    Delete
                  </p>
                )}
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  )
}

export default OptionsForLiked